export default "__VITE_PUBLIC_ASSET__ea60e0aa__"